// Brand logo: gradient infinity mark + "SuperAge Health" wordmark.
export const Logo = ({ variant = "dark", className = "", iconClass = "h-9 w-9", textClass = "text-2xl" }) => {
  const wordColor = variant === "light" ? "text-white" : "text-sa-forest";
  const gid = `inf-grad-${variant}`;
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg viewBox="0 0 24 24" fill="none" className={iconClass} aria-hidden>
        <defs>
          <linearGradient id={gid} x1="0" y1="12" x2="24" y2="12" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor={variant === "light" ? "#EBE8E0" : "#0A2E22"} />
            <stop offset="100%" stopColor="#C67B5C" />
          </linearGradient>
        </defs>
        <path
          d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"
          stroke={`url(#${gid})`}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className={`font-display font-semibold tracking-tight leading-none whitespace-nowrap ${textClass} ${wordColor}`}>
        SuperAge <span className="text-sa-copper">Health<sup className="text-[0.5em] font-medium">™</sup></span>
      </span>
    </div>
  );
};

export default Logo;
